import { parse, setYear } from 'date-fns';

import {
  COLLECTION_DATE_FORMAT,
  DC_RESOURCE_TYPE,
  ES_RESOURCE_TYPE,
  OPEN_ACCESS,
  RESTRICTED_ACCESS,
} from '../constants';
import { type DOI } from './doi';

export function getAccessibilityStatus(doi: DOI): string | undefined {
  const { resourceType, collectionDate, releaseDate, publicationYear } = doi;
  if (resourceType === ES_RESOURCE_TYPE) {
    const comparisonDate = releaseDate || collectionDate;
    if (publicationYear && comparisonDate) {
      // take day and month of comparisonDate (released date or session date) and year of publicationYear
      const publiclyAvailableDate = setYear(
        parse(comparisonDate, COLLECTION_DATE_FORMAT, new Date()),
        publicationYear,
      );

      const now = new Date();

      if (now > publiclyAvailableDate) {
        return OPEN_ACCESS;
      }
      if (now <= publiclyAvailableDate) {
        return RESTRICTED_ACCESS;
      }
    }
  } else if (resourceType === DC_RESOURCE_TYPE) {
    return OPEN_ACCESS;
  }
  return undefined;
}
